module.exports = __webpack_public_path__ + "img/abacus_type_6 (old).0a66aac0.png";